/**
 * Compatibility layer for react-loadable with React 19
 * react-loadable doesn't work with React 19, so we replace it with React.lazy + Suspense
 */
import React, { Suspense } from 'react';

const cache = new Map();

export default function Loadable({ loader, loading: LoadingComponent }) {
  // Create the lazy component once, cached to avoid recreation
  let LazyComponent = cache.get(loader);
  if (!LazyComponent) {
    LazyComponent = React.lazy(loader);
    cache.set(loader, LazyComponent);
  }

  // Return a regular function component using React.createElement
  function LoadableComponent(props) {
    const fallback = LoadingComponent
      ? React.createElement(LoadingComponent)
      : React.createElement('div', null, 'Loading...');

    return React.createElement(
      Suspense,
      { fallback },
      React.createElement(LazyComponent, props)
    );
  }

  LoadableComponent.displayName = `Loadable(${LazyComponent.displayName || 'Component'})`;

  return React.memo(LoadableComponent);;
}
